import React from 'react'
import { Outlet, Link, Routes, Route } from 'react-router-dom';
export default function MainLayout() {
  return <Outlet />;
}
